// extracted by mini-css-extract-plugin
module.exports = {"container":"round-icon-container_container__olNvu","medium":"round-icon-container_medium__ENKH1","large":"round-icon-container_large__GDLr_"};